import {animate, query, stagger, style, transition, trigger} from "@angular/animations";
import {TBaseAnimationPayload} from "../types";
import {DEFAULT_ANIMATION_PAYLOAD} from "./default-animation-config";

export const DEFAULT_MODAL_ANIMATION = (offsetRem = 2, timeInSeconds = 0.3) => trigger('modal', [
  transition(':enter', [
    style({transform: `translateY(${offsetRem}rem)`}),
    animate(`${timeInSeconds}s ease`, style({transform: 'translateY(0rem)'}))
  ]),
  transition(':leave', [
    style({transform: 'translateY(0rem)'}),
    animate(`${timeInSeconds}s ease`, style({transform: `translateY(${offsetRem}rem)`}))
  ])
]);

export const DEFAULT_MODAL_CONTAINER_ANIMATION
  = ({duration, timingFunction}: TBaseAnimationPayload = DEFAULT_ANIMATION_PAYLOAD) => trigger('defaultModalContainerAnimation', [
  transition(':enter', [
    style({opacity: 0}),
    animate(`${duration}s ${timingFunction}`, style({opacity: 1}))
  ]),
  transition(':leave', [
    animate(`${duration}s ${timingFunction}`, style({opacity: 0}))
  ]),
  transition(':enter, :leave', [
    query('.layout-component', [
      style({transform: 'translate(-50%, -40%)'}),
      animate(`${duration * 2}s ${timingFunction}`, style({transform: 'translate(-50%, -50%)'})),
    ], {optional: true})
  ])
]);


